/**
 * Action types for Role Based Access functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_ROLES_BASED = 'GET_ROLES_BASED';
export const GET_ROLES_BASED_SUCCESS = 'GET_ROLES_BASED_SUCCESS';
export const GET_ROLES_BASED_FAIL = 'GET_ROLES_BASED_FAIL';
export const DELETE_ROLES_BASED = 'DELETE_ROLES_BASED';
export const DELETE_ROLES_BASED_SUCCESS = 'DELETE_ROLES_BASED_SUCCESS';
export const DELETE_ROLES_BASED_FAIL = 'DELETE_ROLES_BASED_FAIL';
export const ADD_ROLES_BASED = 'ADD_ROLES_BASED';
export const ADD_ROLES_BASED_COMPLETE =  'ADD_ROLES_BASED_COMPLETE';
export const EDIT_ROLES_BASED = 'EDIT_ROLES_BASED'
export const EDIT_ROLES_BASED_COMPLETE =  'EDIT_ROLES_BASED_COMPLETE'
export const GET_IOCP_CAPTIVE_PORTALS_LIST = 'GET_IOCP_CAPTIVE_PORTALS_LIST';
export const GET_IOCP_CAPTIVE_PORTALS_LIST_SUCCESS = 'GET_IOCP_CAPTIVE_PORTALS_LIST_SUCCESS';
export const GET_IOCP_CAPTIVE_PORTALS_LIST_FAIL = 'GET_IOCP_CAPTIVE_PORTALS_LIST_FAIL';